import React from 'react';
import styled from 'styled-components';
import { T } from 'components/Translation/Translation';

const Label = styled.label`
	font-size: 1.5rem;
	color: #474747;
	letter-spacing: 0;
	display: block;
	width: 100%;
`;

const GroupHeader = styled.header`
	display: block;
	width: 100%;
`;

export const FieldHeader = ({
	className = '',
	label,
	required,
	translation,
}) => (
	<GroupHeader className={className}>
		<Label>
			{label} {required ? '*' : ''}
		</Label>
		<T name={translation} />
	</GroupHeader>
);
